import _ from 'lodash'

const displayPrice = (x, shouldSubtractCarriage) => {
  // Subtract carriage and it's tax if necessary
  const price = Math.floor(x) - (shouldSubtractCarriage ? 648 : 0)
  return Number(price).toLocaleString()
}

const priceCaption = withoutCarriage => `(${ withoutCarriage ? '' : '送料･' }税込)`

/*
  Note:
  wedding-sweets-volume, one-moreは東栄商品だが送料を引いて表示したい。
  wedding-sweetsは送料なしの外部商品の価格が入っているため、引く必要がない。
  価格の持ち方を直すチケットで解消予定
  */

// Pass result to priceCaption(); Only for caption
const isUndeliverableFeature = featureId => _.includes(
  ['wedding-sweets', 'wedding-sweets-volume', 'one-more'],
  featureId
)

// For actual price modification
const shouldCarriageOfItemsInFeatureSubtracted = featureId => _.includes(
  ['wedding-sweets-volume', 'one-more'],
  featureId
)

// サイトを回遊されたくないfeatureか。
const isStandaloneFeature = featureId => _.startsWith(featureId, 'wildcard')

const makeS3URL = path => `https://s3-ap-northeast-1.amazonaws.com/selects-tc-viewer-public${path}`

export default {
  displayPrice,
  priceCaption,
  isUndeliverableFeature,
  shouldCarriageOfItemsInFeatureSubtracted,
  isStandaloneFeature,
  makeS3URL,
}



// WEBPACK FOOTER //
// ./src/util.js